import { useNavigate } from 'react-router-dom';

import { useAuth0 } from '@auth0/auth0-react';
import { Link } from '@mui/material';

import AccessDenied from '@/components/shared/AccessDenied';
import { email } from '@/config';

const NotFound = () => {
  const navigate = useNavigate();
  const { logout } = useAuth0();

  return (
    <AccessDenied
      title="Page Not Found"
      description={
        <>
          We couldn’t find the page you’re looking for. If you believe this is
          an error, reach out to your organization’s administrator or contact{' '}
          <Link href={`mailto:${email}`} sx={{ color: 'primary.main' }}>
            {email}
          </Link>{' '}
          for help.
        </>
      }
      actionButtons={{
        primary: {
          label: 'Go Back',
          onClick: () => navigate(-1),
        },
        secondary: {
          label: 'Log Out',
          onClick: () => logout(),
        },
      }}
    />
  );
};

export default NotFound;
